import { useEffect } from "react";
import {
  React,
  Heading,
  // Steps,
  Button,
  Text,
  Shortcut,
  Row, 
  Col,
} from "mondrian-react";
import { logger } from "utils/logger";
import "./style.scss";
import { handleDate, onLinkIsClicked } from "./actions.js";
// import { isMobile } from "react-device-detect";
import useIsTotem from "hooks/useIsTotem";
import useIsPJ from "hooks/useIsPJ";
import { reportGA4, reportPageViewGA4 } from "utils/pushDataLayer";


const FaturaEmpty = ({ handleButtonClick, msisdn }) => {
  // const [steps] = React.useState([
  //   {
  //     title: "Celular",
  //     status: "doing",
  //   },
  //   {
  //     title: isMobile ? "Código" : "Código de segurança",
  //     status: "doing",
  //   },
  //   {
  //     title: "Faturas",
  //     status: "doing",
  //   },
  // ]);
  useEffect(() => {
    reportPageViewGA4({ customTitle: 'detalhes_de_fatura' })
  }, [])
  const isTotem = useIsTotem();
  const isPJ = useIsPJ();

  return (
    <div>
      <Heading xs className="mcm-TitleEmpty">
        Você não possui nenhuma fatura em aberto para o número {msisdn}
      </Heading>
      <Text body>Consulta realizada em {handleDate()}</Text>
      <Button onClick={() => {
        handleButtonClick()
        reportGA4({ customTitle: 'detalhes_de_fatura:consultar_outro_numero' })
      }}
        className="mcm-backButton">
        Consultar outro número
      </Button>
      {!isTotem && !isPJ &&
        <Row className="facilities-shortcuts">
        <Col xs={12}>
          <h2 className="mdn-Heading mdn-Heading--sm heading">
            Facilidades no Minha Claro móvel
          </h2>
          <div className="">
            <Shortcut
              onClick={() => {
                logger({ name: "RedirectFaturaDetalhada" });
                reportGA4({ customTitle: 'detalhes_de_fatura:minha_claro_movel' })
              }}
              href="https://minhaclaro.claro.com.br/?redirect-feature=FaturasMinhasFaturas"
              className="card1"
              icon={"mdn-Shortcut-icon mdn-Icon-dinheiro-cifrao-caneta mdn-Icon--md"}
              title="Ir para Fatura detalhada"
              target="_blank"
            >
              Fatura detalhada
            </Shortcut>
            <Shortcut
              onClick={() => {
                logger({ name: "RedirectMudeSeuPlano" });
                reportGA4({ customTitle: 'mude_seu_plano:loja' })
              }}
              href="https://minhaclaro.claro.com.br/?redirect-feature=OutrosPlanos"
              className="card1"
              icon={"mdn-Shortcut-icon mdn-Icon-setas-sentido-oposto mdn-Icon--md"}
              inverse
              title="Ir para Mude seu plano"
              target="_blank"
            >
              Mude seu plano
            </Shortcut>
            <Shortcut
              onClick={() => {
                logger({ name: "RedirectLoja" });
                reportGA4({ customTitle: 'loja:minha_claro_movel' })
              }}
              href="https://minhaclaro.claro.com.br/?redirect-feature=Loja"
              className="card1"
              icon={"mdn-Shortcut-icon mdn-Icon-sacola-cifrao mdn-Icon--md"}
              inverse
              title="Ir para Loja"
              target="_blank"
            >
              Loja
            </Shortcut>
            <Shortcut
              onClick={() => {
                logger({ name: "RedirectSuporteTecnico" });
                reportGA4({ customTitle: 'suporte_tecnico:minha_claro_movel' })
              }}
              href="https://minhaclaro.claro.com.br/?redirect-feature=AtendimentoGuiaSolucoes"
              className="card1"
              icon={"mdn-Shortcut-icon mdn-Icon-chave-combinada-fenda mdn-Icon--md"}
              inverse
              title="Ir para Suporte técnico"
              target="_blank"
            >
              Suporte técnico
            </Shortcut>
            <Shortcut
              onClick={() => {
                logger({ name: "RedirectClaroClube" });
                reportGA4({ customTitle: 'claro_clube:minha_claro_movel' })
              }}
              href="https://minhaclaro.claro.com.br/?redirect-feature=ClaroClubeClienteCadastrado"
              className="card1"
              icon={"mdn-Shortcut-icon mdn-Icon-claro mdn-Icon--md"}
              inverse
              title="Ir para Claro clube"
              target="_blank"
            >
              Claro clube
            </Shortcut>
          </div>
        </Col>
      </Row>
      }
    </div>
  );
};

export default FaturaEmpty;
